import { render, staticRenderFns } from "./SkillPopup.vue?vue&type=template&id=23b7bf10&scoped=true"
import script from "./SkillPopup.vue?vue&type=script&lang=js"
export * from "./SkillPopup.vue?vue&type=script&lang=js"
import style0 from "./SkillPopup.vue?vue&type=style&index=0&id=23b7bf10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b7bf10",
  null
  
)

export default component.exports